export class Ponto {
    ativo: boolean;
    id: number;
    descricao: string;
    nome: string;
    enderecoId: number;
}

export class PontoDeslocamento {
    dataCriacao: string; 
    dataUltimaAlteracao: string; 
    ativo: boolean; 
    deslocamentoId: number; 
    pontoId: number;
    tipo: number;
    id: number; 
    usuarioCriacaoId: number; 
    usuarioUltimaAlteracaoId: number;
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/pontos/shared/ponto.model.ts
 **/